import React from 'react';

import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { TabelaMudas } from '../../components/TabelaMudas';

export default function MudasPage() {

    return (
        <>           
            <MenuMain >
                <TabelaMudas />
            </MenuMain>
            <AppFooter />    
        </>
    );
}
